module.exports = __webpack_public_path__ + "img/1679987888279-Screenshot_2023-03-28-13-39-38-93_3d9111e2d3171bf4882369f490c087b4.jpg.e7b6d14b.webp";